/**
 * Situação da inscrição do freelancer no turno, com nome legível e tom do selo.
 * Mesmos rótulos do `ViewSubmittedEvaluationsModal`; antes as telas do
 * supervisor mostravam o código cru (`APROVADO`, `PENDENTE`...).
 */
export type RegistrationTone = "good" | "warn" | "bad" | "neutral";

const STATUS: Record<string, { label: string; tone: RegistrationTone }> = {
  PENDENTE: { label: "Pendente", tone: "warn" },
  APROVADO: { label: "Aprovado", tone: "good" },
  REJEITADO: { label: "Rejeitado", tone: "bad" },
  FALTOU: { label: "Faltou", tone: "bad" },
  AUSENTE: { label: "Ausente", tone: "bad" },
  CANCELADO: { label: "Cancelado", tone: "neutral" },
};

export const registrationStatusLabel = (status?: string | null): string =>
  (status && STATUS[status.toUpperCase()]?.label) || status || "—";

export const registrationStatusTone = (status?: string | null): RegistrationTone =>
  (status && STATUS[status.toUpperCase()]?.tone) || "neutral";

/** Iniciais para o avatar redondo ("Rafael Souza" → "RS"). */
export const initialsOf = (name?: string | null): string => {
  const parts = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0][0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] ?? "" : "";
  return `${first}${last}`.toUpperCase();
};
